import React from 'react';
import { bool } from 'prop-types';
import { InlineTextButton } from '../../components';

import Icon from '../Icon/Icon';
import css from './VideoPlayer.module.css';

const BigPlayButton = props => {
  const { show } = props;
  return show ? (
    <InlineTextButton className={css.bigPlayButton} type="button">
      <Icon name="play" size={24} className={css.bigPlayIcon} filled />
    </InlineTextButton>
  ) : null;
};

BigPlayButton.defaultProps = {
  show: false,
};

BigPlayButton.propTypes = {
  show: bool.isRequired,
};

export default BigPlayButton;
